<template>
  <v-chip
    :color="color"
    class="ml-0 mr-2 font-weight-bold white--text"
    label
    x-small
    >{{ text }}</v-chip
  >
</template>

<script>
export default {
  props: {
    status: String,
  },
        
  data() {
    return {
      statusList: {
        rejected: {
          color: "error",
          text: "Rejected",
        },
        approved: {
          color: "success",
          text: "Approved",
        },
        saved: {
          color: "secondary",
          text: "Saved",
        },
        sent: {
          color: "info",
          text: "Sent",
        },
      },
    };
  },
  computed: {
    colorize() {
      if (this.statusList[this.status]) {
        return this.statusList[this.status];
      }
      return {
        color: "secondary",
        text: this.status ? this.status : "Not set",
      };
    },
    color() {
      return this.colorize.color;
    },
    text() {
      return this.colorize.text;
    },
  },
};
</script>